import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    processingData: null,
    error: null,
    loading: false,
    insertData: null,
    updateData: null,
    deleteData: null,
    errorInsert: null,
    errorUpdate: null,
    errorDelete: null,
    deleteMany: null,
};

const processingSlice = createSlice({
    name: "processing",
    initialState,
    reducers: {
        getDataAll: (state) => {
            state.loading = true;
        },
        getDataAllSuccess: (state, action) => {
            state.loading = false;
            state.processingData = action.payload;
            state.error = null;
        },
        getDataAllFail: (state, action) => {
            state.loading = false;
            state.processingData = null;
            state.error = action.payload;
        },
        addProcessing: (state) => {
            state.loading = true;
            state.insertData = null;
            state.errorInsert = null;
        },
        addProcessingSuccess: (state, action) => {
            state.loading = false;
            state.insertData = action.payload;
            state.errorInsert = null;
        },
        addProcessingFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.insertData = null;
            state.errorInsert = action.payload;
        },
        updateProcessing: (state) => {
            state.loading = true;
        },
        updateProcessingSuccess: (state, action) => {
            state.loading = false;
            state.updateData = action.payload;
            state.error = null;
        },

        updateProcessingFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteProcessing: (state) => {
            state.loading = true;
        },
        deleteProcessingSuccess: (state, action) => {
            state.loading = false;
            state.deleteData = action.payload;
            state.error = null;
        },
        deleteProcessingFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteManyRequest: (state, action) => {
            state.loading = true;
        },
        deleteManySuccess: (state, action) => {
            state.loading = false;
            state.deleteMany = action.payload;
            state.error = null;
        },
        deleteManyFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        setDataNull: (state) => {
            state.error = null;
            state.insertData = null;
            state.updateData = null;
            state.deleteData = null;
            state.errorInsert = null;
            state.errorUpdate = null;
            state.errorDelete = null;
            state.deleteMany = null;
        },
    },
});

export const {
    getDataAll,
    getDataAllSuccess,
    getDataAllFail,
    addProcessing,
    addProcessingSuccess,
    addProcessingFail,
    updateProcessing,
    updateProcessingSuccess,
    updateProcessingFail,
    deleteProcessing,
    deleteProcessingSuccess,
    deleteProcessingFail,
    deleteManyRequest,
    deleteManyFail,
    deleteManySuccess,

    setDataNull,
} = processingSlice.actions;

export default processingSlice.reducer;
